import { render, staticRenderFns } from "./CTextarea.vue?vue&type=template&id=b8e94b86"
import script from "./CTextarea.vue?vue&type=script&lang=js"
export * from "./CTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e94b86')) {
      api.createRecord('b8e94b86', component.options)
    } else {
      api.reload('b8e94b86', component.options)
    }
    module.hot.accept("./CTextarea.vue?vue&type=template&id=b8e94b86", function () {
      api.rerender('b8e94b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTextarea.vue"
export default component.exports